import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import TokenContext from '../../context/TokenContext';
import { UserAuth } from '../../context/AuthContext';
import { aplicarEventoCodocente, infoPlan, limpiarInformacion } from '../../Redux/universidadInterna';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { COLUMNSINFO } from '../../columnas/columnasInfo';
import TablaInfo from '../tablas/TablaInfo';

const ModalInfo = ({ open, handleClose, maestrocursoid }) => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const { empleado } = UserAuth()

    //ACTIVIDADES HITOS
    const [info, setInfo] = React.useState([])
    const [loadingInfo, setLoadingInfo] = React.useState(false)
    const infoSelector = useSelector(store => store.universidadInterna.infoPlan)
    const getInfoselector = useSelector(store => store.universidadInterna.getInfoPlan)

    React.useEffect(() => {
        if (token && empleado && maestrocursoid) {
            dispatch(infoPlan(token, empleado.usuarioPortalRh, maestrocursoid))
        }
    }, [token, empleado, maestrocursoid])

    React.useEffect(() => {
        if (infoSelector?.length > 0 && getInfoselector === true) {
            var array = []
            infoSelector.forEach(element => {
                var objeto = {
                    id: element.new_participanteporeventodecapacitacionid,
                    _new_eventodecapacitacion_value: element["_new_eventodecapacitacion_value@OData.Community.Display.V1.FormattedValue"],
                    _new_eventodecapacitacion_id: element._new_eventodecapacitacion_value,
                    new_modalidaddecurso: element["ab.new_modalidaddecurso@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setInfo(array)
            setLoadingInfo(true)
        } else if (infoSelector?.length == 0 && getInfoselector === true) {
            setLoadingInfo(true)
        }
    }, [infoSelector, maestrocursoid])

    const cerrarYlimpiar = () => {
        handleClose(false)
        setInfo([])
        setLoadingInfo(false)
        dispatch(limpiarInformacion());
    }

    const handleUpdateEvento = (id) => {
        dispatch(aplicarEventoCodocente(token, id))
            .then((id) => {
                dispatch(infoPlan(token, empleado.usuarioPortalRh, maestrocursoid))
                cerrarYlimpiar()
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    return (
        <Dialog
            open={open}
            onClose={() => cerrarYlimpiar()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='xl'
        >
            <DialogTitle>Información adicional</DialogTitle>
            <DialogContent>
                {
                    !loadingInfo ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                py: 2
                            }}>
                            <CircularProgress color="secondary" />
                        </Box>
                    ) :
                        info.length > 0 ? (
                            <>
                                <TablaInfo columnas={COLUMNSINFO} lineas={info} acciones={true} handleUpdateEvento={handleUpdateEvento} />
                            </>
                        ) :
                            <Alert severity="info">
                                <AlertTitle>Info</AlertTitle>
                                No existen registros de — <strong>Información adicional</strong>.
                            </Alert>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => cerrarYlimpiar()} color="secondary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalInfo